import React from 'react';
import { useParams } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { Button, Modal, message } from 'antd';
import { ExclamationCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { GET_VIREMENTS, DELETE_VIREMENT } from '../../../../../gql/virements';
import { GET_BUDGET } from '../../../../../gql/budgets';
import useLoading from '../../../../../hooks/useLoading';

const { confirm } = Modal;
const showConfirm = ({ onOk }) => {
  confirm({
    title: 'Confrim to Delete?',
    icon: <ExclamationCircleOutlined />,
    content: `Do you want to delete this virement?`,
    onOk,
  });
};

const DeleteVirement = ({ id }) => {
  const { projectId } = useParams();
  const [deleteVirement, { loading: deleteLoading }] = useMutation(
    DELETE_VIREMENT,
    {
      refetchQueries: () => [
        {
          query: GET_VIREMENTS,
          variables: {
            projectIds: [projectId],
            status: ['DRAFT', 'PENDING', 'REJECTED', 'APPROVED', 'VOIDED'],
          },
        },
        {
          query: GET_BUDGET,
          variables: {
            projectIds: [projectId],
            // ids: [fromBudget.id, toBudget.id],
            // virementStatus: [
            //   'DRAFT',
            //   'PENDING',
            //   'APPROVED',
            //   'REJECTED',
            //   'VOIDED',
            // ],
          },
        },
      ],
      awaitRefetchQueries: true,
      onCompleted: () => {
        message.success('Virement deleted successfully');
      },
      onError: () => {},
    }
  );
  useLoading(deleteLoading);

  return (
    <Button
      danger
      type="primary"
      onClick={() => {
        showConfirm({
          onOk: () => {
            deleteVirement({
              variables: {
                input: {
                  id,
                  projectId,
                },
              },
            });
          },
        });
      }}
    >
      <DeleteOutlined />
      Delete
    </Button>
  );
};

DeleteVirement.propTypes = {
  id: PropTypes.string.isRequired,
};

export default DeleteVirement;
